import { Button } from 'components/Buttons/styles';
import { LeftBlock, Wrapper, InputBlock } from 'components/Input/styles'
import styled from 'styled-components'

export const Container = styled.div`
	margin: auto;
	margin-top: 18vh;
	max-width: 50.8rem;
	width: 100%;
	height: fit-content;
	display: flex;
	flex-direction: column;
	form {
		${Button} {
			width: 100%;
		}
	}
`;

export const CheckboxWrapper = styled.div`
	margin-top: ${props => props.top};
	margin-bottom: ${props => props.bottom};
`;

export const Title = styled.div`
	${props => props.theme.fonts.interSemibold32};
	color: ${props => props.theme.colors.white100};
`;

export const Column = styled.div`
	display: flex;
	flex-direction: column;
	align-items: ${props => props.alignItems ? props.alignItems : "center"};
	gap: ${props => props.gap ? props.gap : "1.2rem"};
	margin-bottom: ${props => props.bottom};
	${Wrapper} {
		height: 7rem;
		width: 100%;
		input {
			height: 7rem;
		}
		${LeftBlock} {
			left: 2.4rem;
		}
		${InputBlock} {
			padding-left: 5.6rem;
		}
	}
`;

export const Row = styled.div`
	margin-top: ${props => props.top};
	display: flex;
	align-items: ${props => props.alignItems ? props.alignItems : "center"};
	justify-content: ${props => props.justifyContent ? props.justifyContent : "space-between"};
	gap: ${props => props.gap ? props.gap : "1.2rem"};
	margin-bottom: ${props => props.bottom};
	a {
		${props => props.theme.fonts.interSemibold13}
		color: ${props => props.theme.colors.secondary};
		height: 4rem;
		margin-left: auto;
	}
`;

export const AnotherRegister = styled.div`
	height: 4rem;
	${props => props.theme.fonts.interSemibold13}
	color: ${props => props.theme.colors.secondary};
	margin-top: 1.2rem;
	display: flex;
	align-items: center;
	justify-content: center;
	gap: .8rem;
	a {
		${props => props.theme.fonts.interSemibold13}
		color: ${props => props.theme.colors.white100};
		height: 4rem;
		display: flex;
		align-items: center;
		justify-content: center;
		width: 8rem;
	}
`